import * as React from "react";
import { Tooltip } from "@mui/material";

const SvgComponent = ({ fill = "#000", stroke = "#636F7C", ...props }) => (
  <Tooltip title="show scorecard with retry status" arrow>
    <span>
  <svg
    width={30}
    height={30}
    fill={props.color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={0.5} y={0.5} width={29} height={29} rx={5.5} stroke={stroke} />
    <path
      d="M13.023 19.841h5.954A4.028 4.028 0 0 0 23 15.818a4.028 4.028 0 0 0-4.023-4.023h-.707a.522.522 0 0 0-.516.516c0 .28.235.515.515.515h.708a2.994 2.994 0 0 1 2.991 2.992 2.994 2.994 0 0 1-2.991 2.992h-5.954a2.994 2.994 0 0 1-2.991-2.992 2.994 2.994 0 0 1 2.991-2.992h2.049l-1.37 1.37a.516.516 0 0 0 0 .738c.205.206.53.206.736 0l2.24-2.24a.512.512 0 0 0 .147-.369.581.581 0 0 0-.147-.368l-2.24-2.255a.511.511 0 0 0-.369-.147.516.516 0 0 0-.368.884l1.37 1.37h-2.048A4.028 4.028 0 0 0 9 15.833c0 2.21 1.813 4.008 4.023 4.008Z"
      fill={fill}
      opacity={1}
    />
  </svg>
  </span>
  </Tooltip>
);

export default SvgComponent;